<template>
<form class="form form-horizontal" v-on:submit.prevent="" @submit.prevent="formSubmit">
  <div class="status-text status-text--error" v-html="outputError" @click="clearOutputError"></div>
  <legend>
    Lähetä tarjouspyyntö
  </legend>
<fieldset>
<div class="control-group">
  <label class="control-label uppercase" for="companyName">Yritys</label>
  <div class="col-sm-7 rightcolumn">
      <div class="controls">
        <input id="companyName" name="companyName" type="text" placeholder="Yritys Oy" class="input-xlarge" v-model="formVariables.companyName">
        <!-- <p class="help-block">help</p> -->
      </div>
  </div>
</div>
<div class="control-group">
  <label class="control-label uppercase" for="firstName">Etunimi</label>
  <div class="col-sm-7 rightcolumn">
      <div class="controls">
        <input id="firstName" name="firstName" type="text" placeholder="Matti" class="input-xlarge" v-model="formVariables.firstName">
        <!-- <p class="help-block">help</p> -->
      </div>
  </div>
</div>

<div class="control-group">
  <label class="control-label uppercase" for="lastName">Sukunimi</label>
  <div class="col-sm-7 rightcolumn">
    <div class="controls">
      <input id="lastName" name="lastName" type="text" placeholder="Mallikas" class="input-xlarge" v-model="formVariables.lastName">
    </div>
  </div>
</div>

<div class="control-group">
  <label class="control-label uppercase" for="telephone">Puhelin</label>
  <div class="col-sm-7 rightcolumn">
    <div class="controls">
      <input id="telephone" name="telephone" type="text" placeholder="1234" class="input-xlarge" v-model="formVariables.telephone">
    </div>
  </div>
</div>

<div class="control-group">
  <label class="control-label uppercase" for="email">Sähköposti</label>
  <div class="col-sm-7 rightcolumn">
    <div class="controls">
      <input id="email" name="email" type="text" placeholder="matti@domain.fi" class="input-xlarge" v-model="formVariables.email">
    </div>
  </div>
</div>

<!-- Select Basic -->
<div class="control-group" v-if="option1.enabled">
  <label class="control-label uppercase" for="service" v-html="option1.label"></label>
  <div class="col-sm-7 rightcolumn">
    <div class="select-container">
      <select v-on:change="changeOption1(selectedAreaID, $event)" v-model="option1.options" id="option1" name="option1" class="form-control">
        <option value="">valitse...</option>
        <option v-for="option in option1.options" v-bind:key="option.id" :value="option.name">{{option.name}}</option>
      </select>
    </div>
  </div>
</div>

<div class="control-group">
  <label class="control-label uppercase" for="details">Lisätiedot</label>
  <div class="col-sm-7 rightcolumn">
    <div class="controls">
      <textarea name="details" maxlength="200" type="text" placeholder="Mahdolliset lisätiedot..." class="input-xlarge" v-model="formVariables.details">
      </textarea>
    </div>
  </div>
</div>

<div class="control-group terms-accepted">
  <label class="control-label control-label--long" for="">
    <p class="help-block text--help">Hyväksyn että tietoni tallennetaan <a v-bind:href="privacyPolicyUrl" target="_blank">tietosuojaselosteen</a> mukaisesti</p></label>
  <div class="col-sm-2 terms-accepted-checkbox">
    <div class="controls">
      <label class="checkbox termsaccepted-label" for="termsAccepted">
        <input v-model="termsAccepted" type="checkbox" name="termsAccepted" id="termsAccepted" value="1">
        Kyllä
      </label>
    </div>
  </div>
</div>

<!-- Button -->
<div class="control-group">
  <div class="controls">
    <button id="submitButton" name="submitButton" class="btn btn-success">Lähetä</button>
    <button type="button" id="cancelButton" name="cancelButton" class="btn btn-default" @click="cancelForm">Peruuta</button>
  </div>
  <div class="status-text" v-html="output">
  </div>
</div>

</fieldset>
</form>
</template>

<script>
/* eslint-disable no-unused-vars */
/* eslint-disable no-unreachable */
import axios from 'axios'

export default {
  name: 'ContactForm',
  components: {
  },
  props: {
    data: Object,
  },
  data() {
    return {
      name: '',
      description: '',
      output: '',
      outputError: '',
      selectedDate: '',
      selectedService: '1',
      termsAccepted:false,
      timer: 0,
      formVariables: {
        companyName : '',
        firstName : '',
        lastName : '',
        telephone : '',
        email : '',
        model : '',
        modelName : '',
        details: ''
      },
      option1: {
        label: 'Valinta 1 - todo',
        enabled: false,
        options: [
        { id: 100, name: 'test1' },
        { id: 101, name: 'test2' },
        ]
      }
   }
  },
  mounted() {
  },
  computed: {
    privacyPolicyUrl: function () {
        let ppUrl = this.$parent.companySettings.privacy_policy_url;
        if(ppUrl == undefined || ppUrl == '') {
            return '#';
        }
        else {
            return ppUrl;
        }
    },
  },
  methods: {
    thankYouPageUrl: function () {
        let typUrl = this.$parent.companySettings.thank_you_page_url;
        if(typUrl == undefined || typUrl == '') {
            return '';
        }
        else {
            return typUrl;
        }
    },
    thankYouFrame: function () {
        return this.$parent.companySettings.thankyou_inframe;
    },
    clearOutputError() {
      this.outputError = '';
      clearTimeout(this.timer);
    },
    cancelForm() {
        this.$emit('cancel');
        return false;
    },
    formSubmit(e) {
      function validateEmail(email) {
        // eslint-disable-next-line
        var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;

        if (reg.test(email) == false) {
          return false;
        }
        else {
          return true;
        }
      }

      function check(val) {
        if(val == '') {
          return false;
        }
        return true;
      }
      let formEndpoint = process.env.VUE_APP_BOX_FORM_POST_ENDPOINT;
      this.formVariables.model = this.$parent.model; //box model number
      this.formVariables.modelName = this.$parent.modelName; //box modelName from parent

      //this.formVariables.selectedPersonID = this.$parent.var123;

      let boxParams = this.$parent.$refs.boxsliders.getBoxSubmitData(); //access boxslider to get string
      console.log('boxParams:');
      console.log(boxParams);

      var msg='';
      if(this.termsAccepted != 1) {
        alert('Sinun on hyväksyttävä ehdot ennen tietojen lähettämistä');
        return false;
        //msg = msg + '<p>Hyväksy ehdot ennen lomakkeen lähettämistä</p>';
      }

      if(!validateEmail(this.formVariables.email)) {
        msg = msg + '<p>Tarkista sähköpostiosoitteen oikeellisuus</p>';
      }

      if(!check(this.formVariables.firstName)) { msg = msg + '<p>Täytä etunimi</p>'; }
      if(!check(this.formVariables.lastName)) { msg = msg + '<p>Täytä sukunimi</p>'; }
      if(!check(this.formVariables.telephone)) { msg = msg + '<p>Täytä puhelinnumero</p>'; }
      if(!check(this.formVariables.email)) { msg = msg + '<p>Täytä Sähköpostiosoite</p>'; }

      var currentObj = this;
      clearTimeout(this.timer);


      if(msg.length > 2) {
        this.outputError = msg;
        this.timer = setTimeout(function() {
          msg = '';
          currentObj.outputError = '';
        }, 6000);
        return;
      }
      else {
        this.outputError='';
      }
      //DEBUG
      //return false;
      
      const formDataSubmit = new FormData();//sending as formdata
      console.log('thisformdata:');
      console.debug(this.formVariables);
      Object.keys(this.formVariables).forEach(key => {
        console.log(key, this.formVariables[key]);
        formDataSubmit.append(key, this.formVariables[key]); //append ALL to formData
      });

      //formDataSubmit.append('first_name', this.formVariables.first_name);
      console.log('formDataSubmit: ');
      console.debug(formDataSubmit);


      //console.log('DEBUG RETURN');
      //return;

      axios.post(formEndpoint+boxParams, formDataSubmit)
      .then(function (response) {
        currentObj.output = response.data;
        /*@@TODO fix */
        //this.output = 'Viesti lähetetty';

        if(response.data.indexOf('OK') !== -1) {
          currentObj.formVariables.companyName = '';
          currentObj.formVariables.firstName = '';
          currentObj.formVariables.lastName = '';
          currentObj.formVariables.telephone = '';
          currentObj.formVariables.email = '';
          //currentObj.formVariables.streetAddress = '';
          //currentObj.formVariables.postalCode = '';
          //currentObj.formVariables.city = '';
          currentObj.formVariables.details = '';
          currentObj.termsAccepted = false;


          var typUrl = currentObj.thankYouPageUrl();
          var thankyou_inframe = parseInt(currentObj.thankYouFrame(), 10);
          setTimeout(function() {
            if(thankyou_inframe && typUrl != '') {
              window.location.href = typUrl;
            }
            else if(typUrl != '') {
                if (window.self !== window.top) { 
                  window.parent.location.href = typUrl;
                } else {
                  window.location.href = typUrl;
                }
              }
            else {
              console.log('no redirection');
            }
          }, 3000);

        }
      })
      .catch(function (error) {
        currentObj.outputError = error;
      });

    }


  }
}





</script>
<style scoped>
/* @import '../styles/bs_strip.css'; */
/* @import '../styles/fonts.css'; */

.form label, .form input, .form textarea {
  /*font-family: 'PT Sans', sans-serif;*/
  /*font-family: 'PT Sans Narrow', sans-serif;*/
  font-family: 'Lato', Arial, sans-serif;
}

form.form {
  position: relative;
  padding-bottom: 6px;
}
.form fieldset {
  margin: 0;
  padding: 0;
  margin-left: 4px;
  padding-left:7px;
  padding-right:7px;
}

.control-group {
  display: block;
  clear:both;
}
.control-label {
  float: left;
  min-width: 160px;
  max-width: 180px;
}
label.uppercase {
    text-transform: uppercase;
}
label > small {
    font-weight: 400;
    text-transform: none;
}
.control-label--long {
  min-width: 160px;
  max-width: 100%;
  width: 82%;
  text-align: left;
  font-size: 12px;
  line-height: 20px;
  padding-top: 8px;
}
.select-container {
  margin-left: 20px;
  margin-right: 20px;
}
#service {
  width: 100%;
}
label .text--help {
  font-weight:normal;
}
label .help-block.text--help a {
  color:#2222ff;
  text-decoration:underline;
}
#termsAccepted {
  float: none;
  text-align: center;
}
.termsaccepted-label {
  margin-left: 12px;
}
.terms-accepted-checkbox {
  padding-top: 10px;
}
.form textarea {
  width: 270px;
  max-width: 200px;
  min-width: 200px;
  max-height: 180px;
}

button, .btn {
  font-family: 'Lato', Arial, sans-serif;
  font-size: 15px;
  line-height: 18px;
  font-weight: 400;
  margin-left: 10px;
  margin-right: 10px;
}
select {
  height: 30px;
  width: 100%;
  background-color: #fff;
  border: 1px solid #ccc;
}

input[type=checkbox]
{
  /* Double-sized Checkboxes */
  -ms-transform: scale(1.2); /* IE */
  -moz-transform: scale(1.2); /* FF */
  -webkit-transform: scale(1.2); /* Safari and Chrome */
  -o-transform: scale(1.2); /* Opera */
  transform: scale(1.2);
  padding: 10px;
}

label.checkbox
{
  /* Checkbox text */
  font-size: 15px;
}

@media only screen and (min-width: 320px) and (max-width: 800px) {

  legend {
    margin-bottom: 4px;
  }
  .control-label {
    float: none;
    max-width: 100%;
    width: 100%;
    clear: both;
    text-align: center;
    display: block;
    margin-top: 6px;
  }

  .checkbox.termsaccepted-label {
    margin-left:auto;
    padding-top: 0px;
  }
  .terms-accepted-checkbox {
    margin-top: 0px;
    margin-bottom: 10px;
    padding-top: 0px;
  }
}

</style>

<style>
.status-text {
  font-size: 20px;
  line-height: 43px;
}
.status-text--error {
  position: absolute;
  margin-top: 50px; 
  background: #f1f1f1;
  border-radius: 4px;
  border: 1px #e5e5e5 solid;
  padding: 15px;
  padding-bottom: 45px;
  z-index: 200;
  box-shadow: 1px 2px 20px 6px rgb(0 0 0 / 8%);
  margin-left: auto;
  margin-right: auto;
  /* min-width: 320px; */
  /* width: 80%; */
  left: 50px;
  right: 50px;
}

.status-text--error > p:first-child {
  margin-top: 15px;
}

.status-text p, .status-text > p {
  line-height: 22px;
  font-size: 16px;
  margin-top: 0px;
  margin-bottom: 0px;
  font-weight: bold;
}

.status-text--error p, .status-text--error > p {
  font-size: 13px;
  color:#202020;
}

.status-text--error:empty {
  display:none;
}

</style>

